import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss']
})
export class CookiePolicyComponent implements OnInit {

  constructor(private meta: Meta, private title: Title, private metaService: MetaServiceService) {
    //  SEO Meta Description
    this.meta.addTags([
      { name: 'description', content: 'Cookie Policy CViewSurvey: If you want to know about cookie policy of our web and mobile survey application, just reach out to the CViewSurvey cookie policy page or contact us. Register to CViewSurvey website.' },
      { name: 'author', content: 'cookies' },
      { name: 'keywords', content: 'Survey App, survey application, web and mobile survey application' }
    ]);

    this.setTitle('Cookie Policy | Web and Mobile Survey Application | CViewSurvey');
    // End SEO Meta Description

  }


  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description


  ngOnInit(): void {
    // for create canonical link 
    this.metaService.createCanonicalURL();  
  }

}
